export default __webpack_public_path__ + "static/media/Nav-Pledges.eb3fd9d1.svg";